import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import zeplinColor from '../../../theme/Color';

type CustomModalProp = {
  open?: boolean;
  handleCloseModal?: () => void;
};

const CustomLoader = ({ open = false, handleCloseModal }: CustomModalProp) => {
  return (
    <Modal
      open={open}
      aria-labelledby='modal-modal-title'
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'transparent' },
        },
      }}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 100,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',

          width: '156px',
          height: '112px',
          backgroundColor: 'transparent',
          padding: '24px',

          '&:focus': {
            outline: 'none', // Removes the blue outline
          },
        }}
      >
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          <CircularProgress sx={{ color: zeplinColor.BasicBlack }} size={80} />
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img src='/assets/a-a-loader.svg' alt='loading' width={32} height={32} />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default CustomLoader;
